import React from 'react';

import cn from 'classnames';

import { Skeleton } from '@shared/ui';

import cls from './PaymentsListSkeleton.module.css';

interface PaymentsListSkeletonProps {
    classes?: string;
}

export const PaymentsListSkeleton = ({ classes }: PaymentsListSkeletonProps) => (
    <div className={cn(cls.PaymentsListSkeleton, [classes])}>
        <div className={cls.header}>
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
        </div>
        <div className={cls.item}>
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <div />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
        </div>
        <div className={cls.item}>
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
        </div>
        <div className={cls.item}>
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <div />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
        </div>
        <div className={cls.item}>
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <div />
            <Skeleton height={16} border="2px" />
            <Skeleton height={16} border="2px" />
            <div />
            <Skeleton height={16} border="2px" />
        </div>
    </div>
);
